/* Pizzalovers Pizzateig-Rechner – Rechenlogik (Vanilla JS, keine Abhängigkeiten).
   Zustand lebt in der URL (?p=…&n=…&g=…), damit Rezepte teilbar bleiben.

   HEFE-MODELL (direkte Teige, nach Confraternita-Logik: Zeit × Temperatur × Kühlschrankanteil)
   ------------------------------------------------------------------------------------
   Hefeaktivität verdoppelt sich grob alle 7 °C:  r(T) = 2^((T − 20) / 7)
   Wirksame Gärstunden:                           H = Stunden_RT · r(Raumtemp.) + Stunden_Kühl · r(Kühltemp.)
   Frischhefe in g pro kg Mehl:                   y = 76.3 / H^1.337   (geklemmt auf 0.3 … 10 g/kg)
   Kalibriert auf PizzApp 1.9 (Claudios Entscheid 12.10.2026, „ich verlasse mich auf die PizzApp"), zwei Messpunkte:
     Grundrezept 6 × 280 g, 65 %, 2.8 % Salz, 5 h/20 °C + 18 h/4 °C → PizzApp 4.23 g (H = 8.70 → 4.23 g/kg)
     6 × 260 g, 60 %, 3 % Salz, 8 h/20 °C + 43 h/4 °C             → PizzApp 1.67 g (H = 16.8 → 1.75 g/kg)
   Kontrollwerte: 24 h bei 20 °C → ca. 1.1 g/kg · 8 h bei 20 °C → ca. 4.7 g/kg · 6 h bei 20 °C → ca. 7 g/kg.
   Trockenhefe = Frischhefe ÷ 3. Vorteig-Presets (Biga, Poolish) nutzen feste Prozentwerte aus den Rezepten.
   Salz = % vom Mehl (3 % bei 60 % Hydration entspricht 50 g pro Liter Wasser).
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-pl-teigrechner]');
  if (!root) return;

  /* ---------- Presets ---------- */
  var PRESETS = {
    contemporanea: {
      name: 'Napoletana', short: 'Napoletana', unitN: 'Pizzen', unitG: 'Teigling',
      desc: 'Unser Standard: hoher, luftiger Rand, dünner Boden, lange kalte Führung im Kühlschrank. Für Pizzaofen und heissen Backofen mit Stein.',
      hyd: 65, ball: 280, salt: 2.8, oil: 0, sugar: 0, semola: 0, yeast: 'fresh', tool: 'spiral',
      rtHours: 5, fridge: 18, rt: 20, kt: 4, diff: 'Mittel', oven: '430–480 °C', pre: null,
      recipe: '/blogs/rezepte/grundrezept-pizzateig-by-claudio-lo-bello'
    },
    classica: {
      name: 'Napoletana Verace (AVPN)', short: 'Verace', unitN: 'Pizzen', unitG: 'Teigling',
      desc: 'Das Original nach dem Reglement der Associazione Verace Pizza Napoletana: nur Mehl, Wasser, Salz und Hefe, Reifung bei Raumtemperatur, 60–90 Sekunden bei über 430 °C.',
      hyd: 60, ball: 250, salt: 3, oil: 0, sugar: 0, semola: 0, yeast: 'fresh', tool: 'spiral',
      rtHours: 24, fridge: 0, rt: 22, kt: 4, diff: 'Mittel', oven: '430–480 °C', pre: null,
      recipe: ''
    },
    teglia: {
      name: 'Blechpizza (Pizza in Teglia)', short: 'Blechpizza', unitN: 'Bleche', unitG: 'Teig pro Blech',
      desc: 'Hoch, luftig und knusprig vom Blech, römische Art. Sehr nasser Teig, darum Spiralkneter oder Küchenmaschine. Geht auch im normalen Backofen. 650 g reichen für ein Blaublech 30 × 40 cm.',
      hyd: 78, ball: 650, salt: 2.5, oil: 2, sugar: 0, semola: 0, yeast: 'fresh', tool: 'spiral',
      rtHours: 4, fridge: 24, rt: 20, kt: 4, diff: 'Mittel', oven: '250–300 °C', pre: null,
      recipe: ''
    },
    romana: {
      name: 'Pizza Romana (Scrocchiarella)', short: 'Romana', unitN: 'Pizzen', unitG: 'Teigling',
      desc: 'Dünn, knusprig, mit Olivenöl und etwas Semola im Teig. Der Teig reift über Nacht im Kühlschrank und wird bei moderater Hitze länger gebacken.',
      hyd: 60, ball: 220, salt: 2.5, oil: 2.5, sugar: 0, semola: 10, yeast: 'dry', tool: 'hand',
      rtHours: 6, fridge: 18, rt: 20, kt: 4, diff: 'Einfach', oven: '320–350 °C', pre: null,
      recipe: '/blogs/rezepte/scrocchiarella-romana-das-perfekte-rezept-fur-knusprige-pizza'
    },
    biga: {
      name: 'Biga (50 % Vorteig)', short: 'Biga', unitN: 'Pizzen', unitG: 'Teigling',
      desc: 'Fester Vorteig für grosse Poren, viel Aroma und einen leichten Teig. 72 % Hydration, deshalb Spiralkneter oder Küchenmaschine. Für Fortgeschrittene.',
      hyd: 72, ball: 280, salt: 2.6, oil: 1, sugar: 1, semola: 0, yeast: 'fresh', tool: 'spiral',
      rtHours: 24, fridge: 0, rt: 20, kt: 4, diff: 'Fortgeschritten', oven: '450–500 °C',
      pre: { type: 'biga', share: 50, hyd: 45, yeastPct: 0.6, doughYeastPct: 0.4, hours: '16–20 h bei ca. 18 °C' },
      recipe: '/blogs/rezepte/50-biga-50-autolyse'
    },
    poolish: {
      name: 'Poolish (30 % Vorteig)', short: 'Poolish', unitN: 'Pizzen', unitG: 'Teigling',
      desc: 'Flüssiger Vorteig aus gleichen Teilen Mehl und Wasser. Milder Geschmack, zarte Krume, einfacher zu kneten als Biga.',
      hyd: 65, ball: 280, salt: 2.5, oil: 0, sugar: 0, semola: 0, yeast: 'fresh', tool: 'spiral',
      rtHours: 24, fridge: 0, rt: 20, kt: 4, diff: 'Mittel', oven: '400–480 °C',
      pre: { type: 'poolish', share: 30, hyd: 100, yeastPct: 0.2, doughYeastPct: 0.15, hours: '1 h bei Raumtemperatur, dann 12–16 h im Kühlschrank' },
      recipe: ''
    }
  };
  var ALIASES = { grundrezept: 'contemporanea', napoletana: 'classica' }; // alte geteilte Links
  var PRESET_ORDER = ['contemporanea', 'classica', 'teglia', 'romana', 'biga', 'poolish'];

  var TOOLS = {
    spiral:  { name: 'Spiralkneter',    maxHyd: 80, knead: 'im Spiralkneter auf niedriger Stufe 10–15 Minuten kneten, bis der Teig glatt ist und sich vom Rand löst' },
    machine: { name: 'Küchenmaschine',  maxHyd: 72, knead: 'mit dem Knethaken 12–18 Minuten auf niedriger Stufe kneten, zwischendurch den Rand abschaben' },
    hand:    { name: 'Von Hand',        maxHyd: 65, knead: 'von Hand 15–20 Minuten kneten: drücken, falten, drehen, bis der Teig glatt und elastisch ist' }
  };
  var YEAST = { fresh: { name: 'Frischhefe', factor: 1 }, dry: { name: 'Trockenhefe', factor: 1 / 3 } };

  var LIMITS = { n: [1, 50], g: [120, 1500], h: [50, 90], s: [1, 4], o: [0, 8], r: [1, 72], f: [0, 96], rt: [14, 30], kt: [2, 8] };

  /* ---------- Zustand ---------- */
  var state = {};

  function applyPreset(id) {
    id = ALIASES[id] || id;
    var p = PRESETS[id] || PRESETS.contemporanea;
    state = { p: PRESETS[id] ? id : 'contemporanea', n: (id === 'teglia' ? 2 : 4), g: p.ball, h: p.hyd, s: p.salt, o: p.oil, y: p.yeast, w: p.tool, r: p.rtHours, f: p.fridge, rt: p.rt, kt: p.kt };
  }

  function readUrl() {
    var q = new URLSearchParams(location.search);
    applyPreset(q.get('p') || 'contemporanea');
    ['n', 'g', 'h', 's', 'o', 'r', 'f', 'rt', 'kt'].forEach(function (k) {
      if (q.has(k)) { var v = parseFloat(q.get(k)); if (!isNaN(v)) state[k] = clamp(k, v); }
    });
    // alte Links (t = Gesamtzeit) weiter lesbar
    if (q.has('t') && !q.has('r')) { var t = parseFloat(q.get('t')); if (!isNaN(t)) state.r = clamp('r', t - state.f); }
    if (YEAST[q.get('y')]) state.y = q.get('y');
    if (TOOLS[q.get('w')]) state.w = q.get('w');
  }

  function writeUrl() {
    var q = new URLSearchParams(location.search); // fremde Parameter (z. B. view=, utm_) bleiben erhalten
    q.delete('t');
    Object.keys(state).forEach(function (k) { q.set(k, state[k]); });
    history.replaceState(null, '', location.pathname + '?' + q.toString());
  }

  function clamp(k, v) {
    var l = LIMITS[k]; if (!l) return v;
    return Math.min(l[1], Math.max(l[0], v));
  }

  /* ---------- Rechnen ---------- */
  function yeastPerKg(rtHours, f, rt, kt) {
    var r = function (T) { return Math.pow(2, (T - 20) / 7); };
    var H = Math.max(1, rtHours * r(rt) + f * r(kt));
    return Math.min(10, Math.max(0.3, 76.3 / Math.pow(H, 1.337)));
  }

  function plan(rtHours, f) {
    // Aufteilung der Raumtemperatur-Stunden in Stockgare (vor dem Kühlschrank) und Stückgare (vor dem Backen)
    if (f > 0) return { bulk: 1, fridge: f, proof: Math.max(1, rtHours - 1) };
    var proof = Math.max(2, Math.round(rtHours * 0.3));
    return { bulk: Math.max(1, rtHours - proof), fridge: 0, proof: proof };
  }

  function calc() {
    var p = PRESETS[state.p];
    var hyd = state.h / 100, saltF = state.s / 100, oilF = state.o / 100, sugarF = p.sugar / 100;
    var yF;
    if (p.pre) yF = (p.pre.yeastPct * p.pre.share / 100 + p.pre.doughYeastPct) / 100;
    else yF = yeastPerKg(state.r, state.f, state.rt, state.kt) / 1000;

    var total = state.n * state.g;
    var flour = total / (1 + hyd + saltF + oilF + sugarF + yF);
    var r = {
      total: total, flour: flour, water: flour * hyd, salt: flour * saltF, oil: flour * oilF, sugar: flour * sugarF,
      yeastFresh: flour * yF, yeastPerKg: yF * 1000, semola: flour * p.semola / 100, plan: plan(state.r, state.f)
    };
    r.yeast = r.yeastFresh * YEAST[state.y].factor;
    r.flourMain = flour - r.semola;
    if (p.pre) {
      var pf = flour * p.pre.share / 100;
      r.pre = { flour: pf, water: pf * p.pre.hyd / 100, yeast: pf * p.pre.yeastPct / 100 * YEAST[state.y].factor };
      r.main = { flour: flour - pf, water: r.water - r.pre.water, yeast: flour * p.pre.doughYeastPct / 100 * YEAST[state.y].factor };
      if (p.pre.type === 'biga') { r.main.autoWater = r.main.flour * 0.55; r.main.restWater = r.main.water - r.main.autoWater; }
    }
    return r;
  }

  /* ---------- Formatieren ---------- */
  function g(v) { return Math.round(v).toLocaleString('de-CH') + ' g'; }
  function g1(v) { var x = Math.round(v * 10) / 10; return (x % 1 === 0 ? x.toFixed(0) : x.toFixed(1)) + ' g'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Zutaten-Kacheln ---------- */
  function tiles(r) {
    var p = PRESETS[state.p], yn = YEAST[state.y].name, groups = [];
    if (!p.pre) {
      var items = [];
      if (r.semola > 0) { items.push(['Mehl Typ 0', g(r.flourMain)]); items.push(['Semola', g(r.semola)]); }
      else items.push(['Mehl', g(r.flour)]);
      items.push(['Wasser', g(r.water)], ['Salz', g(r.salt)], [yn, g1(r.yeast)]);
      if (r.oil > 0) items.push(['Olivenöl', g(r.oil)]);
      if (r.sugar > 0) items.push(['Honig / Malz', g(r.sugar)]);
      groups.push({ title: 'Deine Zutaten', items: items });
    } else {
      groups.push({ title: p.pre.type === 'biga' ? 'Biga (Vorteig)' : 'Poolish (Vorteig)', items: [['Mehl', g(r.pre.flour)], ['Wasser', g(r.pre.water)], [yn, g1(r.pre.yeast)]] });
      var m = [['Mehl', g(r.main.flour)], ['Wasser', g(r.main.water)], ['Salz', g(r.salt)], [yn, g1(r.main.yeast)]];
      if (r.oil > 0) m.push(['Olivenöl', g(r.oil)]);
      if (r.sugar > 0) m.push(['Honig / Malz', g(r.sugar)]);
      groups.push({ title: 'Hauptteig', items: m });
    }
    var html = groups.map(function (grp) {
      return '<div class="tr-tiles__group"><h3 class="tr-h3">' + esc(grp.title) + '</h3><div class="tr-tiles">' +
        grp.items.map(function (it) { return '<div class="tr-tile"><span class="tr-tile__label">' + esc(it[0]) + '</span><span class="tr-tile__value">' + esc(it[1]) + '</span></div>'; }).join('') +
        '</div></div>';
    }).join('');
    if (state.y === 'dry') {
      var dry = p.pre ? r.pre.yeast + r.main.yeast : r.yeast;
      html += '<p class="tr-muted tr-tiles__note">' + esc(g1(dry) + ' Trockenhefe = ' + g1(dry * 3) + ' Frischhefe (Faktor ein Drittel). Caputo Lievito Secco direkt ins Mehl geben, nicht auflösen.') + '</p>';
    }
    return html;
  }

  /* ---------- Schritte ---------- */
  function steps(r) {
    var p = PRESETS[state.p], pl = r.plan, tool = TOOLS[state.w], yn = YEAST[state.y].name, s = [];
    var n = state.n, ball = state.g, rt = state.rt + ' °C';
    var b = function (t, body) { s.push(['<b>' + t + '</b>', body]); };

    if (state.p === 'contemporanea') {
      b('Mehl und Hefe vermischen', g(r.flour) + ' Mehl mit ' + g1(r.yeast) + ' ' + yn + ' in die Knetschüssel geben und auf niedriger Stufe gut vermischen.');
      b('Wasser schrittweise einarbeiten', 'Nach und nach ca. 80–85 % des Wassers (' + g(r.water * 0.82) + ' von ' + g(r.water) + ') zugeben und kneten, bis das Mehl alles aufgenommen hat. Dann den Rest in kleinen Portionen unterarbeiten. Eiskaltes Wasser verwenden: Die Teigtemperatur darf 25 °C nicht überschreiten.');
      b('Salz einarbeiten', 'Wenn noch ca. ' + g(r.water * 0.1) + ' Wasser übrig sind, ' + g(r.salt) + ' Salz einarbeiten und ' + tool.knead + '.');
      b('Stretch & Fold und Stockgare', 'Den Teig 2–4 Mal dehnen und über sich selbst falten, zur Kugel formen und ' + pl.bulk + ' h abgedeckt bei Raumtemperatur ruhen lassen.' + (pl.fridge ? ' Danach im verschlossenen Behälter ' + pl.fridge + ' h in den Kühlschrank (' + state.kt + ' °C).' : ''));
      b('Teigballen formen', 'Den Teig in ' + n + ' Ballen à ' + ball + ' g teilen, rund wirken und Spannung aufbauen.');
      b('Stückgare', 'Die Ballen mit Abstand in die leicht bemehlte Teigballen-Box legen und ' + pl.proof + ' h bei Raumtemperatur (' + rt + ') gehen lassen. Fertig, wenn der Teig auf Fingerdruck langsam zurückfedert.');
      b('Backen', 'Pizzaofen auf ' + p.oven + ' vorheizen, Backofen mit Stein auf Maximum. Den Teig von Hand ausziehen und den Rand nicht drücken, damit er hoch und luftig wird. 60–120 Sekunden backen.');
    } else if (state.p === 'classica') {
      b('Wasser und Salz', g(r.water) + ' Wasser (ca. 20 °C) in die Schüssel geben und ' + g(r.salt) + ' Salz darin auflösen.');
      b('Hefe', 'Ca. 10 % des Mehls (' + g(r.flour * 0.1) + ') einrühren, dann ' + g1(r.yeast) + ' ' + yn + ' darin auflösen.');
      b('Mehl und kneten', 'Das restliche Mehl (' + g(r.flour * 0.9) + ') nach und nach zugeben und ' + tool.knead + '. Ziel: glatt, elastisch, nicht klebrig.');
      b('Stockgare', pl.bulk + ' h abgedeckt bei Raumtemperatur (' + rt + ') ruhen lassen.');
      b('Teigballen formen', n + ' Ballen à ' + ball + ' g formen (Staglio) und mit Abstand in die Teigballen-Box legen.');
      b('Stückgare', pl.fridge ? pl.fridge + ' h im Kühlschrank (' + state.kt + ' °C) reifen lassen, dann ' + pl.proof + ' h bei Raumtemperatur akklimatisieren.' : pl.proof + ' h bei Raumtemperatur (' + rt + ') reifen lassen, bis die Ballen weich und gut aufgegangen sind.');
      b('Backen', 'Ofen auf ' + p.oven + ' bringen. Ballen in Semola ausziehen, Rand nicht platt drücken, 60–90 Sekunden backen und dabei drehen.');
    } else if (state.p === 'teglia') {
      b('Mehl, Hefe und Wasser', g(r.flour) + ' Mehl mit ' + g1(r.yeast) + ' ' + yn + ' mischen, ca. 80 % des Wassers (' + g(r.water * 0.8) + ') zugeben und ' + tool.knead + '.');
      b('Salz, Restwasser, Öl', g(r.salt) + ' Salz zugeben, dann die restlichen ' + g(r.water * 0.2) + ' Wasser in kleinen Portionen einkneten, zuletzt ' + g(r.oil) + ' Olivenöl. Der Teig ist sehr weich, das ist richtig.');
      b('Falten und Stockgare', 'Im geölten Behälter 3 Mal alle 30 Minuten dehnen und falten, dann ' + (pl.fridge ? pl.fridge + ' h im Kühlschrank (' + state.kt + ' °C)' : pl.bulk + ' h bei Raumtemperatur') + ' reifen lassen.');
      b('Teilen und akklimatisieren', 'Den Teig in ' + n + ' Stücke à ' + ball + ' g teilen, locker rund formen und ' + pl.proof + ' h abgedeckt bei Raumtemperatur (' + rt + ') gehen lassen.');
      b('Ins Blech', 'Das Blaublech (30 × 40 cm für ca. 650 g) grosszügig ölen, den Teig mit geölten Fingerspitzen von der Mitte nach aussen drücken, nicht ausrollen. 45–60 Minuten gehen lassen.');
      b('Backen', 'Ofen auf ' + p.oven + ' vorheizen, unterste Schiene. 12–15 Minuten backen, nach der Hälfte belegen. Fertig, wenn der Boden knusprig und goldbraun ist.');
    } else if (state.p === 'romana') {
      b('Alle Zutaten mischen', g(r.flourMain) + ' Mehl Typ 0, ' + g(r.semola) + ' Semola, ' + g(r.water) + ' Wasser, ' + g(r.salt) + ' Salz, ' + g(r.oil) + ' Olivenöl und ' + g1(r.yeast) + ' ' + yn + ' grob zu einem Teig mischen und 20 Minuten ruhen lassen.');
      b('Falten', 'Den Teig einmal falten, 20 Minuten ruhen lassen und nochmals falten.');
      b(pl.fridge ? 'Kühlschrank' : 'Stockgare', pl.fridge ? 'Im verschlossenen Behälter ' + pl.fridge + ' h im Kühlschrank (' + state.kt + ' °C) gehen lassen.' : pl.bulk + ' h abgedeckt bei Raumtemperatur gehen lassen.');
      b('Teilen', 'Den Teig in ' + n + ' Stücke à ' + ball + ' g teilen und ' + pl.proof + ' h bei Raumtemperatur (' + rt + ') ruhen lassen.');
      b('Backen', 'Dünn ausziehen oder ausrollen, dünn belegen und bei ' + p.oven + ' (Effeuno: alle Thermostate) 3–4 Minuten backen, bis der Boden knusprig ist.');
    } else if (state.p === 'biga') {
      b('Biga ansetzen (Vortag)', g(r.pre.flour) + ' backstarkes Mehl (W 320+), ' + g(r.pre.water) + ' Wasser und ' + g1(r.pre.yeast) + ' ' + yn + ' nur grob zu Klumpen mischen, nicht kneten. Zugedeckt ' + p.pre.hours + ' reifen lassen.');
      b('Autolyse (2 h vor Ende der Biga-Reifung)', g(r.main.flour) + ' Mehl mit ' + g(r.main.autoWater) + ' kaltem Wasser 2–3 Minuten mischen und mindestens 1 h zugedeckt stehen lassen.');
      b('Hauptteig', 'Biga, Autolyseteig, ' + g1(r.main.yeast) + ' ' + yn + ' und ' + g(r.sugar) + ' Honig oder Malz in die Maschine geben. Die restlichen ' + g(r.main.restWater) + ' Wasser tropfenweise zugeben, zum Schluss ' + g(r.salt) + ' Salz' + (r.oil > 0 ? ' und ' + g(r.oil) + ' Olivenöl' : '') + '. 12–15 Minuten kneten, Fenstertest, Teigtemperatur maximal 26–28 °C.');
      b('Stärkungsfalten', 'Dreimal alle 20 Minuten dehnen und falten (Coil Fold).');
      b('Teigballen formen', n + ' Ballen à ' + ball + ' g formen und zugedeckt in die Teigballen-Box legen.');
      b('Stückgare', '3–4 h bei Raumtemperatur (' + rt + ') gehen lassen, je nach Temperatur.');
      b('Backen', 'Ofen auf ' + p.oven + ' vorheizen, 60–90 Sekunden backen.');
    } else if (state.p === 'poolish') {
      b('Poolish ansetzen (Vortag)', g(r.pre.flour) + ' Mehl, ' + g(r.pre.water) + ' Wasser und ' + g1(r.pre.yeast) + ' ' + yn + ' glatt rühren. ' + p.pre.hours + '. Fertig, wenn die Oberfläche voller Blasen ist und leicht einfällt.');
      b('Hauptteig', 'Poolish mit ' + g(r.main.flour) + ' Mehl, ' + g(r.main.water) + ' kaltem Wasser und ' + g1(r.main.yeast) + ' ' + yn + ' mischen, ' + tool.knead + '. ' + g(r.salt) + ' Salz zum Schluss einarbeiten.');
      b('Stockgare', '1–2 h abgedeckt bei Raumtemperatur (' + rt + ') ruhen lassen.');
      b('Teigballen formen', n + ' Ballen à ' + ball + ' g formen und in die Teigballen-Box legen.');
      b('Stückgare', '4–6 h bei Raumtemperatur oder über Nacht im Kühlschrank, dann 2 h akklimatisieren.');
      b('Backen', 'Ofen auf ' + p.oven + ' vorheizen und 60–120 Sekunden backen.');
    }
    return s.map(function (st, i) { return '<li class="tr-step"><span class="tr-step__num">' + (i + 1) + '</span><div class="tr-step__text">' + st[0] + ' · ' + st[1] + '</div></li>'; }).join('');
  }

  /* ---------- Rezept-Details ---------- */
  function details(r) {
    var p = PRESETS[state.p];
    var time = p.pre ? 'ca. 24 h' : 'ca. ' + (state.r + state.f) + ' h';
    var items = [
      ['Gesamtzeit', time], ['Vorteig', p.pre ? (p.pre.type === 'biga' ? 'Biga' : 'Poolish') : 'nein'],
      ['Schwierigkeit', p.diff], ['Ergibt', state.n + ' ' + (p.unitN === 'Bleche' ? (state.n === 1 ? 'Blech' : 'Bleche') : (state.n === 1 ? 'Pizza' : 'Pizzen')) + ' à ' + state.g + ' g'],
      ['Hydration', state.h + ' %'], ['Ofen', p.oven]
    ];
    return items.map(function (it) { return '<div class="tr-detail"><span class="tr-detail__label">' + esc(it[0]) + '</span><span class="tr-detail__value">' + esc(it[1]) + '</span></div>'; }).join('');
  }

  /* ---------- Teilen ---------- */
  function shareText(r) {
    var p = PRESETS[state.p], yn = YEAST[state.y].name, lines = ['Pizzateig: ' + p.name + ' (' + state.n + ' ' + p.unitN + ' à ' + state.g + ' g, ' + state.h + ' % Hydration)'];
    if (!p.pre) {
      if (r.semola > 0) lines.push('Mehl Typ 0 ' + g(r.flourMain), 'Semola ' + g(r.semola)); else lines.push('Mehl ' + g(r.flour));
      lines.push('Wasser ' + g(r.water), 'Salz ' + g(r.salt), yn + ' ' + g1(r.yeast));
      if (r.oil > 0) lines.push('Olivenöl ' + g(r.oil));
    } else {
      lines.push('Vorteig: Mehl ' + g(r.pre.flour) + ', Wasser ' + g(r.pre.water) + ', ' + yn + ' ' + g1(r.pre.yeast));
      lines.push('Hauptteig: Mehl ' + g(r.main.flour) + ', Wasser ' + g(r.main.water) + ', Salz ' + g(r.salt) + ', ' + yn + ' ' + g1(r.main.yeast));
    }
    lines.push('', location.href);
    return lines.join('\n');
  }

  /* ---------- Rendern ---------- */
  var $ = function (sel) { return root.querySelector(sel); };
  var el = {
    chips: root.querySelectorAll('[data-tr-preset]'), n: $('#tr-n'), g: $('#tr-g'), h: $('#tr-h'),
    s: $('#tr-s'), o: $('#tr-o'), r: $('#tr-r'), f: $('#tr-f'), rt: $('#tr-rt'), kt: $('#tr-kt'), y: $('#tr-y'), w: $('#tr-w'),
    timeGroup: root.querySelectorAll('[data-tr-time]'), title: $('#tr-title'), desc: $('#tr-desc'), tiles: $('#tr-tiles'),
    steps: $('#tr-steps'), details: $('#tr-details'), warn: $('#tr-warn'), yeastNote: $('#tr-yeast-note'),
    recipe: $('#tr-recipe'), flours: root.querySelectorAll('[data-tr-flour]'), toast: $('#tr-toast')
  };

  function render() {
    var p = PRESETS[state.p], r = calc(), tool = TOOLS[state.w];
    el.chips.forEach(function (c) { var on = c.getAttribute('data-tr-preset') === state.p; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on); });
    el.n.value = state.n; el.g.value = state.g; el.h.value = state.h;
    var labN = root.querySelector('label[for="tr-n"]'), labG = root.querySelector('label[for="tr-g"] .tr-label-text');
    if (labN) labN.textContent = p.unitN;
    if (labG) labG.textContent = p.unitG;
    el.s.value = state.s; el.o.value = state.o; el.r.value = state.r; el.f.value = state.f; el.rt.value = state.rt; el.kt.value = state.kt; el.y.value = state.y; el.w.value = state.w;
    el.timeGroup.forEach(function (x) { x.hidden = !!p.pre; });
    el.title.textContent = p.name; el.desc.textContent = p.desc;
    el.tiles.innerHTML = tiles(r); el.steps.innerHTML = steps(r); el.details.innerHTML = details(r);

    var warn = [];
    if (state.h > tool.maxHyd) warn.push(tool.name + ': Wir empfehlen maximal ' + tool.maxHyd + ' % Hydration, sonst wird der Teig schwer zu verarbeiten.');
    if (!p.pre && state.f > 0 && state.r < 2) warn.push('Plane nach dem Kühlschrank mindestens 2 h bei Raumtemperatur ein, damit die Ballen aufgehen.');
    el.warn.innerHTML = warn.map(function (w) { return '<p class="tr-warn__item">' + esc(w) + '</p>'; }).join('');
    el.warn.hidden = warn.length === 0;

    el.yeastNote.textContent = p.pre
      ? 'Hefe nach Rezept: ' + p.pre.yeastPct + ' % im Vorteig, ' + p.pre.doughYeastPct + ' % im Hauptteig.'
      : 'Hefe berechnet für ' + (state.f ? state.f + ' h bei ' + state.kt + ' °C + ' : '') + state.r + ' h bei ' + state.rt + ' °C (' + (Math.round(r.yeastPerKg * 10) / 10) + ' g Frischhefe pro kg Mehl).';

    if (el.recipe) { el.recipe.hidden = !p.recipe; if (p.recipe) el.recipe.href = p.recipe; }
    el.flours.forEach(function (x) { x.hidden = x.getAttribute('data-tr-flour') !== state.p; });
    writeUrl();
    return r;
  }

  function toast(msg) {
    if (!el.toast) return;
    el.toast.textContent = msg; el.toast.hidden = false;
    clearTimeout(toast.t); toast.t = setTimeout(function () { el.toast.hidden = true; }, 2200);
  }

  /* ---------- Events ---------- */
  el.chips.forEach(function (c) {
    c.addEventListener('click', function () { applyPreset(c.getAttribute('data-tr-preset')); render(); });
  });
  root.querySelectorAll('[data-tr-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var parts = btn.getAttribute('data-tr-step').split(':'), k = parts[0], d = parseFloat(parts[1]);
      state[k] = clamp(k, Math.round((state[k] + d) * 10) / 10); render();
    });
  });
  [['n', el.n], ['g', el.g], ['h', el.h], ['s', el.s], ['o', el.o], ['r', el.r], ['f', el.f], ['rt', el.rt], ['kt', el.kt]].forEach(function (pair) {
    pair[1].addEventListener('change', function () {
      var v = parseFloat(String(pair[1].value).replace(',', '.')); if (isNaN(v)) v = state[pair[0]];
      state[pair[0]] = clamp(pair[0], Math.round(v * 10) / 10);
      render();
    });
  });
  el.y.addEventListener('change', function () { state.y = el.y.value; render(); });
  el.w.addEventListener('change', function () { state.w = el.w.value; render(); });

  var btnShare = $('#tr-share'), btnCopy = $('#tr-copy'), btnWa = $('#tr-whatsapp'), btnCopyRecipe = $('#tr-copy-recipe');
  if (btnShare) btnShare.addEventListener('click', function () {
    var r = calc();
    if (navigator.share) navigator.share({ title: 'Pizzateig-Rechner – Pizzalovers', text: shareText(r) }).catch(function () {});
    else { copy(location.href); toast('Link kopiert'); }
  });
  if (btnCopy) btnCopy.addEventListener('click', function () { copy(location.href); toast('Link kopiert'); });
  if (btnCopyRecipe) btnCopyRecipe.addEventListener('click', function () { copy(shareText(calc())); toast('Rezept kopiert'); });
  if (btnWa) btnWa.addEventListener('click', function () {
    window.open('https://wa.me/?text=' + encodeURIComponent(shareText(calc())), '_blank', 'noopener');
  });
  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).catch(function () {});
    else { var ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); }
  }

  readUrl();
  render();
  root.classList.add('is-ready');
})();
